import type { TabsTabProps } from "@mantine/core";

type TabProps = TabsTabProps & { label: string };

export enum PersonWizardTabValue {
  General = "general",
  RegulatoryDuties = "regulatorische-daten",
  TaxFormulae = "daten-steuerformulare",
  Deliveries = "stromlieferung-und-abrechnung",
  History = "historie"
}

export const PERSON_WIZARD_TABS: Array<TabProps> = [
  {
    value: PersonWizardTabValue.General,
    label: "Allgemeine Daten"
  },
  {
    value: PersonWizardTabValue.RegulatoryDuties,
    label: "Regulatorische Daten"
  },
  { value: PersonWizardTabValue.TaxFormulae, label: "Daten Steuerformulare" },
  {
    value: PersonWizardTabValue.Deliveries,
    label: "Stromlieferung und Abrechnung"
  },
  { value: PersonWizardTabValue.History, label: "Historie" }
];
